import { getStudioDetail } from '../../../api/studiosApi'
import StudioDescriptions from '../../../components/studios/studio-descriptions/studio-descriptions'
import { IStudio } from '../share-type'
import styles from './studio.module.less'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const Studio = () => {
  const params = useParams()
  const [studioId] = useState<string | undefined>(params?.id)
  const [studio, setStudio] = useState<IStudio>()
  useEffect(() => {
    loadStudioDetail()
  }, [studioId])

  const loadStudioDetail = () => {
    if (studioId) {
      getStudioDetail(Number(studioId)).then(res => {
        setStudio(res)
      })
    }
  }

  return (
    <Space className={styles['studio-desc-wrapper']} orientation="vertical" size={16}>
      {studio && <StudioDescriptions studio={studio} onLoadStudioDetail={loadStudioDetail} />}
    </Space>
  )
}

export default Studio
